import {Injectable, signal} from '@angular/core';
import {ExposureDebuggingObject} from "../types/debugging.type";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {DebuggingModalComponent} from "../debugging-modal.component";
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class DebuggingService {
    exposureDebuggingObject = new BehaviorSubject<Record<string, ExposureDebuggingObject>>({});

    alertMessage: string = ''

    constructor(
        private readonly matDialog: MatDialog,
    ) {
    }

    showDebuggingAlert(alertMessage: string): void {
        this.alertMessage = alertMessage;

        this.matDialog.open(DebuggingModalComponent);

        // const dialogRef = this.matDialog.open(DebuggingModalComponent);
        // dialogRef.afterClosed().subscribe(result => {
        //     console.log('The dialog was closed');
        // });
    }
}
